import { Injectable, signal } from '@angular/core';

export interface WizardStep {
  id: number;
  label: string;
  completed: boolean;
  active: boolean;
  icon?: string;
  command?: () => void;
  disabled?: boolean;
  hidden?: boolean; // For hiding steps dynamically (e.g., Atto di Nomina when GDPR is disabled)
  tooltipMessage?: string; // Tooltip message when step is disabled
}

@Injectable({
  providedIn: 'root'
})
export class WizardStepService {
  steps = signal<WizardStep[]>([
    { id: 0, label: 'Anagrafica', completed: false, active: true },
    { id: 1, label: 'Dettagli Anagrafica', completed: false, active: false }
  ]);

  currentStep = signal<number>(0);

  setStep(stepId: number): void {
    this.currentStep.set(stepId);
    const updatedSteps = this.steps().map(step => ({
      ...step,
      active: step.id === stepId
    }));
    this.steps.set(updatedSteps);
  }

  markStepCompleted(stepId: number, completed: boolean): void {
    const updatedSteps = this.steps().map(step =>
      step.id === stepId ? { ...step, completed } : step
    );
    this.steps.set(updatedSteps);
  }

  reset(): void {
    this.steps.set([
      { id: 0, label: 'Anagrafica', completed: false, active: true },
      { id: 1, label: 'Dettagli Anagrafica', completed: false, active: false }
    ]);
    this.currentStep.set(0);
  }
}
